import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import CloseButton from '../CloseButton/index.js';
const Popover = /*#__PURE__*/React.forwardRef(function (_temp, outerRef) {
  let {
    arrowOffsetLeft,
    arrowOffsetTop,
    children,
    className,
    enablePopper = false,
    id,
    positionTop,
    positionLeft,
    placement = 'right',
    show = true,
    target,
    transition = true,
    onCloseClick,
    overlayRef,
    inverse = false,
    width = 'default',
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const handleCloseClick = e => {
    target?.click();
    onCloseClick(e);
  };
  const props = {};
  const arrowStyle = {};
  props.style = {
    top: positionTop,
    left: positionLeft,
    ...rest?.style
  };

  // A fallback strategy for Popovers used with Overlay
  if (!enablePopper || !target) {
    // add a data-popper attribute for arrow styling
    props['data-popper-placement'] = placement;
    arrowStyle.top = arrowOffsetTop;
    arrowStyle.left = arrowOffsetLeft;
  }
  const classNames = clsx('popover fade', {
    [placement]: true,
    in: transition,
    inverse,
    [width]: width === 'narrow'
  }, className);
  return /*#__PURE__*/React.createElement("div", Object.assign({}, rest, props, {
    id: id,
    ref: outerRef || overlayRef,
    role: "tooltip",
    className: classNames
  }), /*#__PURE__*/_jsx("div", {
    className: "arrow",
    "data-popper-arrow": true,
    style: {
      ...arrowStyle
    }
  }), onCloseClick && /*#__PURE__*/_jsx("div", {
    className: "display-flex justify-content-end padding-bottom-0 padding-horizontal-2 padding-top-1"
  }, void 0, /*#__PURE__*/_jsx(CloseButton, {
    onClick: handleCloseClick,
    inverse: inverse
  })), /*#__PURE__*/_jsx("div", {
    className: "popover-content"
  }, void 0, children));
});
export default Popover;